import styled from 'styled-components';
import { commifyNumber } from '../../../../helpers/common';
import { useTranslation } from 'next-i18next';

interface PriceSectionProps {
  type: string;
  price: number;
  currency?: string;
}

interface PriceInfoProps {
  developerSalePrice: number;
  resalePrice: number;
  currency?: string;
}
const PriceSection = ({ type, price, currency }: PriceSectionProps) => {
  const { t } = useTranslation(['common', 'map']);

  return (
    <PriceSectionContainer>
      <span className="type">{t(`${type}_start_price`, { ns: 'map' })} </span>

      {!price || price === 0 ? (
        <span className="price-placeholder">{t('prices_tbd')}</span>
      ) : (
        <div className="price">
          <span className="amount">{commifyNumber(price)}</span>
          <span className="currency">
            {currency || t('egp', { ns: 'map' })}
          </span>
        </div>
      )}
    </PriceSectionContainer>
  );
};

const PriceInfo = ({
  developerSalePrice,
  resalePrice,
  currency
}: PriceInfoProps) => {
  return (
    <Container>
      {developerSalePrice &&
      developerSalePrice > 0 &&
      developerSalePrice !== resalePrice ? (
        <PriceSection
          type="developer"
          price={developerSalePrice}
          currency={currency}
        />
      ) : (
        <></>
      )}

      {developerSalePrice &&
      developerSalePrice > 0 &&
      resalePrice &&
      resalePrice > 0 &&
      developerSalePrice !== resalePrice ? (
        <div className="divider" />
      ) : (
        <></>
      )}

      {resalePrice && resalePrice > 0 ? (
        <PriceSection type="resale" price={resalePrice} currency={currency} />
      ) : (
        <></>
      )}
    </Container>
  );
};

const PriceSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .type {
    color: #697586;
    font-size: 14px;
    font-family: materialMedium;
    text-transform: capitalize;

    .start-price {
      font-size: 14px;
      font-weight: materialMedium;
      color: #697586;
      text-transform: lowercase;
    }
  }

  .price-placeholder {
    color: #2c3138;
    font-size: 14px;
    font-family: materialBold;
  }

  .price {
    display: flex;
    align-items: center;
    gap: 2px;

    .amount {
      color: #2c3138;
      font-family: materialBold;
      font-size: 18px;
      text-transform: uppercase;
    }

    .currency {
      color: #697586;
      font-family: materialRegular;
      font-size: 14px;
      text-transform: uppercase;
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    .type {
      font-size: 13px;

      .start-price {
        font-size: 13px;
      }
    }

    .price {
      gap: 4px;

      .amount {
        font-size: 17px;
      }

      .currency {
        font-size: 12px;
      }
    }
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;

  .divider {
    height: 58px;
    border: 1px solid #d1d4d9;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    .divider {
      height: 43px;
    }
  }
`;

export default PriceInfo;
